import TaskSwimLane from "./TaskSwimLane";
import {Checkbox} from "primereact/checkbox";
import React, {useState} from "react";

const TaskSwimLanes = () => {
    const [showCompleted, setShowCompleted] = useState(false);

    return (<div className="task-swimlanes">
        <div className="show-completed-tasks">
            <Checkbox inputId="show-completed" checked={showCompleted} onChange={e => setShowCompleted(e.checked)} />
            <label htmlFor="show-completed">Show Completed Tasks</label>
        </div>
        <div className="task-swimlanes-section">
            <TaskSwimLane name="To Do" status="ToDo" paginator={false} show={true} />
            <TaskSwimLane name="Doing" status="Doing" paginator={false} show={true} />
        </div>
        {showCompleted && <div className="task-swimlanes-section">    
            <TaskSwimLane name="Done" status="Done" paginator={true} show={showCompleted} />
        </div>}
    </div>)
}

export default TaskSwimLanes;